module.exports = __webpack_public_path__ + "static/media/icon-check.0f537a5d.svg";